// src/PrivacyPolicy.js
import React from 'react';
import './privacypolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <div className="container">
        <h1>Privacy Policy</h1>
        <p><strong>Effective Date:</strong> 19 June 2025</p>
        <p>At Grease Monkey, we respect your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your data when you use our mobile application.</p>
        <p>By using the App, you agree to the terms described in this Privacy Policy. If you do not agree, please do not use the App.</p>

        <h2>1. Information We Collect</h2>
        <h3>a) Personal Information</h3>
        <p>We collect basic personal information when you register or use the App, including:</p>
        <ul>
          <li>Name, email address, phone number, and password</li>
          <li>Vehicle details (for Users)</li>
          <li>Garage details, services, and Garage Drivers (for Garage owners)</li>
          <li>Driver profile data including name, location, license, and optional profile photo (for Independent Drivers)</li>
        </ul>

        <h3>b) Service & Booking Information</h3>
        <ul>
          <li>Vehicle service requests and booking details</li>
          <li>Service prices (set directly by garage owners)</li>
          <li>Booking history and assigned driver data (if applicable)</li>
        </ul>

        <h3>c) Device Information</h3>
        <p>We may collect limited technical data such as device type and operating system to ensure app performance.</p>

        <h2>2. How We Use Your Information</h2>
        <p>We use your information to:</p>
        <ul>
          <li>Allow users to register, manage profiles, and interact within the app</li>
          <li>Let garage owners create services and set prices</li>
          <li>Enable users to book services and assign pickup options</li>
          <li>Match users with garages or drivers as per booking details</li>
          <li>Maintain booking history and status updates</li>
        </ul>
        <p><strong>Note:</strong> Prices displayed in the app are added by garage owners and are for reference only. The app does not process or facilitate payments.</p>

        <h2>3. User Roles in the App</h2>
        <p>There are four types of users:</p>
        <ul>
          <li><strong>User (Car Owner):</strong> Registers, adds vehicles, books services, chooses how the car will be delivered (self, independent driver, or garage driver).</li>
          <li><strong>Garage:</strong> Registers, adds their garage, creates services (with prices), adds drivers, manages and assigns requests.</li>
          <li><strong>Garage Driver:</strong> Logs in using credentials provided by the garage, and marks requests as complete.</li>
          <li><strong>Independent Driver:</strong> Registers independently, creates a driver profile, and handles service requests initiated by users.</li>
        </ul>

        <h2>4. Information Sharing and Disclosure</h2>
        <p>We only share your data in the following cases:</p>
        <ul>
          <li>With other users, where necessary to fulfill bookings</li>
          <li>With service providers under confidentiality for technical operations (e.g., analytics or error tracking, if used)</li>
          <li>To comply with legal obligations, such as responding to court orders or law enforcement</li>
        </ul>
        <p>We do not sell or rent your personal data to third parties.</p>

        <h2>5. Data Retention</h2>
        <p>We retain your data only for as long as needed to operate the App or meet legal obligations. If you request account deletion, we will remove or anonymize your data unless we are required to retain it by law.</p>

        <h2>6. Data Security</h2>
        <p>We apply reasonable security measures to protect your information from unauthorized access. However, no system is completely secure, and we cannot guarantee absolute security.</p>

        <h2>7. Your Rights</h2>
        <p>Depending on your location, you may have rights to:</p>
        <ul>
          <li>Access your data</li>
          <li>Correct inaccurate data</li>
          <li>Request deletion of your account</li>
          <li>Object to or limit certain uses of your data</li>
        </ul>
        <p>To exercise these rights, email us at <strong>greasemonkeyappllc@gmail.com</strong></p>

        <h2>8. Age Neutrality</h2>
        <p>Grease Monkey is designed for general use. We do not knowingly collect age-related data, and we do not restrict users based on age. Users are expected to provide accurate information during account creation. If we become aware of misuse or inaccurate data, we may take appropriate action, including account review or removal.</p>

        <h2>9. Changes to This Privacy Policy</h2>
        <p>We may occasionally update this Privacy Policy. Changes will be posted in the App. Continued use after changes implies acceptance of the updated policy.</p>

        <h2>10. Contact Us</h2>
        <p>If you have any questions or concerns, please contact us:</p>
        <p><strong>📧 greasemonkeyappllc@gmail.com</strong></p>
        <p>By using Grease Monkey, you confirm that you have read and understood this Privacy Policy.</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
